module.exports = __webpack_public_path__ + "img/image2.336c1801.png";